const VENDOR_FACEBOOK_PIXEL = 'facebook_pixel';
const VENDOR_GOOGLE_ANALYTICS = 'google_analytics';
const VENDOR_GOOGLE_TAG_MANAGER = 'google_tag_manager';
const VENDOR_GOOGLE_ADWORDS = 'google_adwords';

const GTAG_PLACEMENT_KEY = 'gtag:initialised';

const ORGANIZER_TAG_VENDORS = [
    VENDOR_FACEBOOK_PIXEL,
    VENDOR_GOOGLE_ANALYTICS,
    VENDOR_GOOGLE_TAG_MANAGER,
    VENDOR_GOOGLE_ADWORDS,
];

function buildOrganizerTagKey(vendor, identifier) {
    return `${vendor}:${identifier}`;
}

function readOrganizerTagVendor(tagKey) {
    const vendor = typeof tagKey === 'string' ? tagKey.split(':')[0] : null;

    return ORGANIZER_TAG_VENDORS.includes(vendor) ? vendor : null;
}

export {
    VENDOR_FACEBOOK_PIXEL,
    VENDOR_GOOGLE_ANALYTICS,
    VENDOR_GOOGLE_TAG_MANAGER,
    VENDOR_GOOGLE_ADWORDS,
    GTAG_PLACEMENT_KEY,
    buildOrganizerTagKey,
    readOrganizerTagVendor,
};
